import React from 'react';

export default class Page9 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>LEARNING STYLES COMBINATIONS<a
                                                className="supertext1 superBold"
                                                href="further_info.php?course=300"><sup className="">3</sup></a>
                                            </div>

                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport  tablesrink  paraspace1">
                                                <tbody>
                                                <tr>
                                                    <th width="10%" align="left" valign="top"
                                                        className="green_curve supLinesapce">Learning Style
                                                        Combination
                                                    </th>

                                                    <th width="40%" align="left" valign="top"
                                                        className=" green_curve1">Summary
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="lightgreen  ">
                                                        <div className="innerTablePadding1"><p>Dreamer</p></div>
                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="lightgreen  "><p>Spends time reflecting and
                                                        considering information. Needs plenty of time and
                                                        space to digest it, which may produce more thought and
                                                        ideas. May seem 'in a
                                                        world of their own'.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="darkgreen  ">
                                                        <div className="innerTablePadding1"><p>Analyst</p></div>
                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="darkgreen  "><p>Learns by reflecting on and
                                                        'chewing over' information. Needs time to think
                                                        about what is being learned and its implications. May
                                                        not seem interested
                                                        in learning at times, because can appear distant or
                                                        uninvolved.
                                                    </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="lightgreen  ">
                                                        <div className="innerTablePadding1"><p>Socialite</p>
                                                        </div>

                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="lightgreen  "><p>Will listen and begin
                                                        learning to an extent but will be more interested in
                                                        others
                                                        involved – or what else might be going on – than in the
                                                        learning itself. May
                                                        find it difficult to concentrate at times.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="darkgreen ">
                                                        <div className="innerTablePadding1 style_combi">
                                                            <p>Sponge</p></div>
                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="darkgreen  "><p>Soaks up information. Can
                                                        digest a lot of data. May not challenge statements
                                                        or decisions made – even if disagrees or contrary
                                                        evidence is apparent.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="lightgreen  ">
                                                        <div className="innerTablePadding1 style_combi">
                                                            <p>Jelly</p></div>
                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="lightgreen  "><p>Registers information but
                                                        then tends to worry, either about the information
                                                        itself, or about own ability to use it correctly or
                                                        appropriately.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="darkgreen  ">
                                                        <div className="innerTablePadding1 style_combi">
                                                            <p>Connector</p></div>
                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="darkgreen  "><p>Synthesises new information
                                                        with own experiences and the 'wider picture'.
                                                        May lose attention to detail if learning is not closely
                                                        managed or monitored.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="lightgreen  ">
                                                        <div className="innerTablePadding1 style_combi"><p>List
                                                            maker</p></div>
                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="lightgreen  "><p>Organises information and
                                                        plans schedules in order to assimilate information.
                                                        Very organised and focused. May have a tendency to be
                                                        overly prescriptive
                                                        or inflexible.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="darkgreen  ">
                                                        <div className="innerTablePadding1"><p>Facilitator</p>
                                                        </div>

                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="darkgreen  "><p>Opens up discussions,
                                                        challenges assumptions and involves others. Will aim
                                                        to involve others in the learning in order to test it
                                                        and gather evidence to
                                                        establish facts or views.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="lightgreen  ">
                                                        <div className="innerTablePadding1"><p>Fluffy robot</p>
                                                        </div>
                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="lightgreen  "><p>Wants to make logical
                                                        challenges, but is keen not to upset others. Will
                                                        challenge in a very 'nice' way! May be gauging other
                                                        people's views and
                                                        feelings about the information.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="darkgreen  ">
                                                        <div className="innerTablePadding2 lawyer"><p>Lawyer</p>
                                                        </div>
                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="darkgreen  "><p>Logical and factual approach.
                                                        Considers the evidence for and against the
                                                        learning but forms own opinion. Will happily test this
                                                        out on others to check
                                                        concerns. This person's tendency to challenge could be
                                                        interpreted by others
                                                        as 'just being objectionable for the sake of it.'</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="lightgreen  ">
                                                        <div className="innerTablePadding1 style_combi">
                                                            <p>Inventor</p></div>
                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="lightgreen  "><p>Comes up with new ideas or
                                                        different angles and considers how they would
                                                        work in practice. Will try out theories or assumptions
                                                        for the same reasons.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="darkgreen  ">
                                                        <div className="innerTablePadding1"><p>Piston</p></div>

                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="darkgreen  "><p>A doer. Will progress
                                                        learning by considering and applying the practical
                                                        aspects or enabling others to. May become overly focused
                                                        on the practical
                                                        elements of learning to the detriment of the theory.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="lightgreen  ">
                                                        <div className="innerTablePadding1"><p>Coordinator</p>
                                                        </div>

                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="lightgreen  "><p>Works with others to show
                                                        practical aspect of learning. May find it difficult to
                                                        learn alone, preferring to do so with others to
                                                        establish its relevance or
                                                        applicability. Danger of coercing others to learn when
                                                        they don't want to!</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="darkgreen  ">
                                                        <div className="innerTablePadding1"><p>Family</p></div>

                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="darkgreen  "><p>Tries to learn with others.
                                                        Learns best when practising with others who also
                                                        want to do so. Works to help self and others to learn.
                                                        Could slow the learning
                                                        process by taking time to ensure everyone is happy with
                                                        it.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="lightgreen  ">
                                                        <div className="innerTablePadding1"><p>Rebel</p></div>

                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="lightgreen  "><p>Learns in own way. May feel
                                                        constrained and frustrated by impractical or slow
                                                        learning and will often take own, different course of
                                                        action in order to learn.
                                                        May upset, annoy or frustrate trainers.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="darkgreen  ">
                                                        <div className="innerTablePadding1"><p>Puppy</p></div>

                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="darkgreen  "><p>Open to new experiences and
                                                        keen to try out new techniques. Could 'drain'
                                                        others as it's not always apparent this individual has
                                                        absorbed information
                                                        before moving on to the next thing!</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="lightgreen  ">
                                                        <div className="style_combi"><p>Monitor</p></div>

                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="lightgreen  "><p>Open minded and willing to
                                                        take on challenges, albeit reasonably cautious.
                                                        This is a 'look before you leap' mentality.</p>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page8')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page10')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}